module.exports = {"150724100":"巴彦托海镇","150724110":"大雁镇","150724111":"伊敏河镇","150724112":"红花尔基镇","150724210":"巴彦查岗苏木","150724211":"锡尼河西苏木","150724212":"锡尼河东苏木","150724213":"巴彦塔拉达斡尔民族乡","150724214":"伊敏苏木","150724215":"辉苏木","150724400":"巴彦托海经济开发区","150724401":"伊敏河高载能工业园区","150724402":"大雁马铃薯高新技术示范园区","150724403":"呼伦贝尔新城区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150724.json
// module id = 450
// module chunks = 0